export function EditorSection({ children }: { children: React.ReactNode }) {
  return (
    <div className="bg-white dark:bg-her-darkSectionBg px-4 md:px-10 py-5 md:py-10 mb-3 grid grid-cols-1 xl:grid-cols-[200px_auto] gap-4 -mx-2 lg:mx-0 rounded-2xl">
      {children}
    </div>
  );
}

export function Title({ subTitle, children }: { subTitle?: string; children: React.ReactNode }) {
  return (
    <div className="text-base font-medium">
      {children}
      {subTitle && <p className="text-xs font-normal mt-2 text-her-greenSheen">{subTitle}</p>}
    </div>
  );
}

export function SubmitPanel({ children }: { children: React.ReactNode }) {
  return (
    <div
      id="submit-panel"
      className="fixed bottom-0 left-0 right-0 bg-white dark:bg-her-darkSectionBg flex items-center justify-end gap-8 px-2 md:px-10 py-3 shadow-[10px_4px_10px_0px_#0000001A]"
    >
      {children}
    </div>
  );
}
